import React, { Component, useState } from "react";
import Measure from "react-measure";
import shortid from "shortid";
import StackSelector from "./StackSelector";
import { MolstackModel, MolstackMap } from "./Elements";
import { makeStyles } from "@material-ui/core";

const typeToComponent = {
  pdb: MolstackModel,
  mmcif: MolstackModel,
  ccp4_map: MolstackMap,
  map: MolstackMap
};

// class StackViewer extends Component {
//
//   state = {
//     prevProps_active_stack_id: this.props.active_stack_id,
//     active_stack_id: this.props.active_stack_id ||
//                     (this.props.stacks[0] && this.props.stacks[0].id) || null,
//     dimensions: {width: 200, height:200}
//   }
//
//   constructor (props) {
//     super(props);
//     this.onResize = this.onResize.bind(this);
//     this.onStackChange = this.onStackChange.bind(this);
//
//     this.loader = this.props.loader;
//     //this.stacks = this.props.stacks || [];
//
//     this.viewer = this.props.viewer
//     // this.id = shortid.generate();
//     // this.viewer_id = 'st-viewer-' + this.id;
//     // this.viewer = this.props.viewer(this.viewer_id);
//   }
//
//   static getDerivedStateFromProps(props, state) {
//     // Allow the active stack to be controlled from outside as well
//     if (props.active_stack_id !== null &&
//         (props.active_stack_id !== state.prevProps_active_stack_id)) {
//       return {
//         prevProps_active_stack_id: props.active_stack_id,
//         active_stack_id: props.active_stack_id
//       }
//     } else {
//       return null
//     }
//   }
//
//   onResize(contentRect) {
//     let bounds = contentRect.bounds;
//     this.setState({
//       dimensions : {width: bounds.width, height: bounds.height}
//     })
//   }
//
//   onStackChange(stack_id) {
//     this.setState({'active_stack_id': stack_id});
//   }
//
//   getElementsForStack(stack) {
//     if (stack.elements) {
//       return stack.elements.map((element) => {
//         const StackElement = typeToComponent[element.type];
//         return <StackElement
//           key={element.id} id={element.id} url={element.url}
//           {...element.options}
//         />;
//       });
//     } else {
//       return [];
//     }
//   }
//
//   render() {
//     const {width, height} = this.state.dimensions;// || {width: 200, height: 200};
//     const Viewer = this.viewer.Component;
//     const elements = this.getElementsForStack(
//       this.props.stacks.find(s => s.id === this.state.active_stack_id) || [],
//     );
//
//     return <Measure bounds onResize={this.onResize}>
//       {({ contentRect, measureRef}) =>
//         <div ref={measureRef} className={'viewer-panel'} style={{width:"100%",height:"100%", position:"relative"}}>
//           <Viewer
//             key={this.viewer_id}
//             id={this.viewer_id}
//             loader={this.loader}
//             height={height} width={width}
//             view={null}
//             // styling={styling}
//           >
//             {elements}
//           </Viewer>
//           <StackSelector
//             side='right'
//             stacks={this.props.stacks}
//             current={this.state.active_stack_id}
//             onChange={this.onStackChange}
//           />
//         </div>
//       }
//       </Measure>
//   }
// }

function getElementsForStack(stack) {
  if (stack.elements) {
    return stack.elements.map(element => {
      const StackElement = typeToComponent[element.type];
      return (
        <StackElement
          key={element.id}
          id={element.id}
          url={element.url}
          {...element.options}
        />
      );
    });
  } else {
    return [];
  }
}

const useStyle = makeStyles({
  root: {
    margin: "5px",
    flex: "1 1 0",
    overflow: "hidden",
    position: "relative"
  }
});

function StackViewer({
  viewer,
  stacks,
  active_stack_id,
  view,
  onViewChange,
  children,
  ...props
}) {
  const [currentStack, setCurrentStack] = useState(
    (stacks[0] && stacks[0].id) || null
  );
  const [dims, setDimensions] = useState({
    bounds: { width: 200, height: 200 }
  });
  const classes = useStyle(props);

  const Viewer = viewer.Component;
  let elements = [];
  if (active_stack_id && active_stack_id !== currentStack) {
    setCurrentStack(active_stack_id);
    //React will rerender it anyway, but we skip loading unnecessary stack elements
    elements = getElementsForStack(
      stacks.find(s => s.id === active_stack_id) || []
    );
  } else {
    elements = getElementsForStack(
      stacks.find(s => s.id === currentStack) || []
    );
  }

  return (
    <Measure bounds onResize={setDimensions}>
      {({ contentRect, measureRef }) => (
        <div ref={measureRef} className={classes.root}>
          <Viewer
            key={viewer.id}
            id={viewer.id}
            view={view}
            onViewChange={onViewChange}
            height={dims.bounds.height}
            width={dims.bounds.width}
            // styling={styling}
          >
            {elements}
          </Viewer>
          {children}
        </div>
      )}
    </Measure>
  );
}

export default StackViewer;
